export const MAX_TEXT_LENGTH = 120;
